import { DataSource } from '@n7-frontend/core';
import { IInnerTitleData } from '@n7-frontend/components';
export class TitleDS extends DataSource {

  private lastPayload;

  protected transform(data): IInnerTitleData {
    if (!data || !data.userData) {
      return;
    }
    const title = `${data.userData.givenName} ${data.userData.familyName}`;
    const logo = (data.userData.socials && data.userData.socials.picture) || undefined ;
    return {
      image: logo,
      title: {
        main: {
          text: title,
        }
      },
      tools: '',
    };
  }
  
}
